import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DomSanitizer} from '@angular/platform-browser';
import {RestService} from '../shared/rest/rest.service';
import {AlertService} from '../shared/alert.service';

@Component({
  selector: 'app-link-view',
  templateUrl: './link-view.component.html',
  styleUrls: ['./link-view.component.scss']
})
export class LinkViewComponent implements OnInit {

  source;

  constructor(private alertService: AlertService, private route: ActivatedRoute, private sanitizer: DomSanitizer, private restService: RestService) { }

  ngOnInit(): void {

    this.route.paramMap.subscribe(paramMap => {
      if (paramMap.has('id')) {
        this.restService.getHtmlAnchor(paramMap.get("id")).subscribe(value => {
          this.source = this.sanitizer.bypassSecurityTrustHtml(value.page);
        },() => this.alertService.warn('LinkView.error'))

      }
    });
  }

}
